// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".correct_answer-content[data-v-6afff710],.correct_answer-title[data-v-6afff710]{display:block}", ""]);
// Exports
module.exports = exports;
